import { FunctionalComponent, h } from 'preact';

import { IconEmptyState } from 'common/module/icon/empty-state';
import { IconEmptyStateContacted } from 'common/module/icon/empty-state-contacted';
import { IconEmptyStateSaved } from 'common/module/icon/empty-state-saved';
import { IconNotLoggedInState } from 'common/module/icon/not-logged-in-state';
import { MyAccountEmptyListTemplatePropsInterface } from 'common/module/my-account/empty-list/template-props.interface';

import { MyAccountEmptyStateTemplate } from '../empty-state/template';

export const MyAccountEmptyListTemplate: FunctionalComponent<MyAccountEmptyListTemplatePropsInterface> = (props) => {
  let icon = <IconNotLoggedInState />;

  if (props.isUserLoggedIn) {
    icon = <IconEmptyState />;
  } else if (props.isForContacted) {
    icon = <IconEmptyStateContacted />;
  } else if (props.isForSaved) {
    icon = <IconEmptyStateSaved />;
  }

  return <MyAccountEmptyStateTemplate icon={icon} title={props.title} description={props.description} />;
};
